<template>
  <div class="view-contents">
    <div class="row title-row">
      <div class="col section-title section-header">Sites Downloaded for Offline Use</div>
    </div>
    <b-alert
      :show="dismissCountDown"
      dismissible
      variant="success"
      @dismissed="dismissCountDown=0"
      @dismiss-count-down="countDownChanged"
    >
      Site has been removed
    </b-alert>
    <ul>
      <li v-for="site of mySites" :key="site.id">
        <router-link :to="{ name: 'Site', params: { id: site.Id } }">
          {{site.RecordName}}
        </router-link>
          <b-button size="sm" variant="danger" @click="removeFromMySites(site)">
            Remove Site
          </b-button>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'MySites',
  computed: mapState(['mySites']),
  data() {
    return {
      dismissCountDown: 0,
    };
  },
  mounted() {
    this.$store.dispatch('fetchMySites');
    this.$store.dispatch('setCurrentSite', null);
  },
  methods: {
    removeFromMySites(site) {
      this.$store.dispatch('removeFromMySites', site);
      this.showAlert();
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    showAlert() {
      this.dismissCountDown = 5;
    },
  },
};
</script>
